import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Cerchi esercizi su Google sperando di trovare qualcosa di usabile.',
  good: 'Verifiche pronte sul tuo smartphone in 2 clic.'
}, {
  bad: 'Stress prima di ogni lezione: "Come spiego l\'IVA alla Gen Z?"',
  good: 'Percorsi innovativi già strutturati per ogni modulo contabile.'
}, {
  bad: 'Spiegazioni infinite che i tuoi studenti dimenticano il giorno dopo.',
  good: 'Schemi visivi e mappe che si spiegano da soli.'
}, {
  bad: 'Sensazione che i tuoi studenti non capiscano la partita doppia.',
  good: "Progressione chiara dalla prima registrazione al Bilancio d'Esercizio."
}, {
  bad: 'Arrivi a casa e devi ancora scrivere la programmazione annuale.',
  good: "La programmazione bimestrale per tutto l'anno è già pronta."
}, {
  bad: 'Dai sempre gli stessi esercizi e i tuoi studenti smettono di concentrarsi.',
  good: '6 Tomi progressivi con oltre 400 pagine di contenuto reale.'
}, {
  bad: 'Domenica sera davanti al PC a costruire griglie di valutazione.',
  good: 'Griglie ministeriali pronte, compatibili con ClasseViva e Argo.'
}, {
  bad: 'Non sai come gestire gli studenti BES/DSA nelle verifiche di contabilità.',
  good: 'Materiali compensatori e PDP già strutturati per ogni unità.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <div className="grid grid-cols-1 gap-4" data-id="element-51">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a0f0a] border border-red-900/50 rounded-2xl p-6 sm:p-8" data-id="element-52">
            <h3 className="text-2xl font-black text-red-500 mb-6 text-center uppercase tracking-wide" data-id="element-53">
              SENZA il Sistema
              <br data-id="element-54" />
              <span className="text-lg text-red-400/80" data-id="element-55">(Oggi)</span>
            </h3>
            <div className="space-y-4" data-id="element-56">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-57">
                  <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-58">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-59" />
                  </div>
                  <p className="text-gray-300 font-medium" data-id="element-60">{item.bad}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a140a] to-[#0f0a05] border border-brand-orange/50 rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_rgba(249,115,22,0.15)] relative overflow-hidden" data-id="element-61">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-62" />
            <h3 className="text-2xl font-black text-brand-gold mb-6 text-center uppercase tracking-wide" data-id="element-63">
              CON il Sistema
              <br data-id="element-64" />
              <span className="text-lg text-brand-orange/80" data-id="element-65">(Da domani)</span>
            </h3>
            <div className="space-y-4" data-id="element-66">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-67">
                  <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-68">
                    <CheckIcon className="w-5 h-5 text-green-500" data-id="element-69" />
                  </div>
                  <p className="text-brand-cream font-bold" data-id="element-70">{item.good}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}